const cityRandomData = [
    {
        city: "New York",
    },
    {
        city: "London",
    },
    {
        city: "Paris",
    },
    {
        city: "Tokyo",
    },
    {
        city: "Seoul",
    },
    {
        city: "Milan",
    },
    { city: "Devon" },
];

export default cityRandomData;
